import { useState } from 'react';
import type { CatalogSelectionItem } from '../contexts/CatalogMassActions.context';

export interface CatalogProductsSelection {
  selectedItems: Map<string, string>;
  selecteds: string[];
  isSelected: (productId: string) => boolean;
  toggleSelected: (item: CatalogSelectionItem) => void;
  clearSelection: () => void;
}

export const useCatalogProductsSelection = (): CatalogProductsSelection => {
  const [selectedItems, setSelectedItems] = useState<Map<string, string>>(new Map());

  const toggleSelected = ({ productId, sectionProductId }: CatalogSelectionItem) => {
    setSelectedItems((current) => {
      const next = new Map(current);

      if (next.has(productId)) {
        next.delete(productId);
      } else {
        next.set(productId, sectionProductId);
      }

      return next;
    });
  };

  return {
    selectedItems,
    selecteds: [...selectedItems.keys()],
    isSelected: (productId: string) => selectedItems.has(productId),
    toggleSelected,
    clearSelection: () => setSelectedItems(new Map()),
  };
};
